import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

const scrollToCalendar = () => {
    const header = document.getElementById('new-header')
    const apartmentNav = document.getElementById('apartment-nav')
    const calendar = document.getElementById('calendar')
    const continueBookingBtn = document.getElementById('btn_continue_booking')

    if (!header || !apartmentNav || !calendar) return

    const target = continueBookingBtn || calendar
    const scrollTo = target.getBoundingClientRect().top + window.scrollY
    const distance = scrollTo - header.offsetHeight - apartmentNav.offsetHeight - 10

    window.scroll({
        top: distance,
        behavior: 'smooth'
    });
}

const onScrollPage = () => {
    let scroll = window.scrollY;
    let sticky_widget = document.getElementById('sticky_booking');
    let offsetVisibleCalendar = 150;
    let calendar = document.getElementById('calendar');
    let phone_widget = document.getElementsByClassName('fixed-phone')[0];
    let messenger_widget = document.getElementsByClassName('fb_customer_chat_bubble_animated_no_badge')[0];

    if (!calendar) return false;

    if ((scroll + offsetVisibleCalendar) > calendar.offsetTop) {
        sticky_widget.classList.add('hide_widget');

        if (typeof phone_widget !== 'undefined') {
            phone_widget.classList.remove('bottom_sticky_booking_widget');
        }

        if (typeof messenger_widget !== 'undefined') {
            messenger_widget.classList.remove('bottom_sticky_booking_widget');
        }

    } else {
        sticky_widget.classList.remove('hide_widget');

        if (typeof phone_widget !== 'undefined') {
            phone_widget.classList.add('bottom_sticky_booking_widget');
        }

        if (typeof messenger_widget !== 'undefined') {
            messenger_widget.classList.add('bottom_sticky_booking_widget');
        }
    }
}

window.addEventListener("scroll", onScrollPage);
document.getElementById('btn_scroll_to_calendar').addEventListener('click', () => {
    scrollToCalendar();
})